@file:OptIn(InternalResourceApi::class)

package plush_morph_web.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/plush_morph_web.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_217_782_194)
internal val Res.drawable.app_icon: DrawableResource by lazy {
      DrawableResource("drawable:app_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_icon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_000_773_124)
internal val Res.drawable.app_qr_code: DrawableResource by lazy {
      DrawableResource("drawable:app_qr_code", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_qr_code.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(338_424_142)
internal val Res.drawable.app_store_badge: DrawableResource by lazy {
      DrawableResource("drawable:app_store_badge", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_store_badge.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_620_178_205)
internal val Res.drawable.demo_plushie: DrawableResource by lazy {
      DrawableResource("drawable:demo_plushie", setOf(
        ResourceItem(setOf(), "${MD}drawable/demo_plushie.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(890_242_491)
internal val Res.drawable.demo_result: DrawableResource by lazy {
      DrawableResource("drawable:demo_result", setOf(
        ResourceItem(setOf(), "${MD}drawable/demo_result.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_588_312_764)
internal val Res.drawable.demo_result_2: DrawableResource by lazy {
      DrawableResource("drawable:demo_result_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/demo_result_2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-652_706_681)
internal val Res.drawable.demo_user: DrawableResource by lazy {
      DrawableResource("drawable:demo_user", setOf(
        ResourceItem(setOf(), "${MD}drawable/demo_user.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-468_769_624)
internal val Res.drawable.hero_iphone_0: DrawableResource by lazy {
      DrawableResource("drawable:hero_iphone_0", setOf(
        ResourceItem(setOf(), "${MD}drawable/hero_iphone_0.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_755_842_846)
internal val Res.drawable.hero_iphone_1: DrawableResource by lazy {
      DrawableResource("drawable:hero_iphone_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/hero_iphone_1.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectWebMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_icon", Res.drawable.app_icon)
  map.put("app_qr_code", Res.drawable.app_qr_code)
  map.put("app_store_badge", Res.drawable.app_store_badge)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("demo_plushie", Res.drawable.demo_plushie)
  map.put("demo_result", Res.drawable.demo_result)
  map.put("demo_result_2", Res.drawable.demo_result_2)
  map.put("demo_user", Res.drawable.demo_user)
  map.put("hero_iphone_0", Res.drawable.hero_iphone_0)
  map.put("hero_iphone_1", Res.drawable.hero_iphone_1)
}
